module.exports = __webpack_public_path__ + "img/Pyrolysis_2.28953966.jpg";